var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from './utils/axios';
export function register(_a) {
    var SendEmail = _a.SendEmail, IsAdministrateur = _a.IsAdministrateur, Societe = _a.Societe, Login = _a.Login, Email = _a.Email, Nom = _a.Nom, Prenom = _a.Prenom;
    return __awaiter(this, void 0, void 0, function () {
        var result, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios.post('/licence/register', {
                            SendEmail: SendEmail,
                            IsAdministrateur: IsAdministrateur,
                            Societe: Societe,
                            Login: Login,
                            Email: Email,
                            Nom: Nom,
                            Prenom: Prenom,
                        })];
                case 1:
                    result = _b.sent();
                    if (result.data.ErrorMessage) {
                        throw new Error(result.data.ErrorMessage);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _b.sent();
                    console.error(error_1.message);
                    throw new Error(error_1.message);
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function liste() {
    return __awaiter(this, void 0, void 0, function () {
        var data, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios.get('/licence/liste')];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data.licences];
                case 2:
                    error_2 = _a.sent();
                    console.error(error_2.message);
                    throw new Error(error_2.message);
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function create(_a) {
    var Actif = _a.Actif, UseVision = _a.UseVision, UseTva = _a.UseTva, UseDocument = _a.UseDocument, Cle = _a.Cle, SchemaName = _a.SchemaName, Libelle = _a.Libelle;
    return __awaiter(this, void 0, void 0, function () {
        var result, error_3;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios.post('/licence/store', { Actif: Actif, UseVision: UseVision, UseTva: UseTva, UseDocument: UseDocument, Cle: Cle, SchemaName: SchemaName, Libelle: Libelle })];
                case 1:
                    result = _b.sent();
                    if (result.data.ErrorMessage) {
                        throw new Error(result.data.ErrorMessage);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_3 = _b.sent();
                    console.error(error_3.message);
                    throw new Error(error_3.message);
                case 3: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=licence.js.map